import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextComponent extends InputComponent {
    clear = output<void>();

    protected getValidators(): any[] {
        const validators = super.getValidators();
        const meta = this.meta();

        if (meta) {
            if (meta.pattern) {
                validators.push(Validators.pattern(meta.pattern));
            }
            if (meta.maxLength) {
                validators.push(Validators.maxLength(meta.maxLength));
            }
        }
        return validators;
    }

    public onClear() {
        this.formControl()?.setValue('')
        this.clear.emit();
    }
}
